import { atom } from "recoil";
import { IScoreCardDetails, SelectedRowsToDelete } from "../types";

export const scoreCardShowState = atom({
  key: "scoreCardShowState",
  default: false,
});

export const setLinkStateScoreCard = atom({
  key: "setLinkStateScoreCard",
  default: false,
});

export const scorecardAddState = atom({
  key: "scorecardAddState",
  default: false,
});

export const scorecardEditState = atom({
  key: "scorecardEditState",
  default: false,
});

export const rowForEditScorecard = atom<IScoreCardDetails | undefined>({
  key: "rowForEditScorecard",
  default: undefined,
});

export const escalatedCheckBox = atom({
  key: "escalatedCheckBox",
  default: true,
});

export const unknownCheckBox = atom({
  key: "unknownCheckBox",
  default: true,
});

export const fullPayCheckBox = atom({
  key: "fullPayCheckBox",
  default: true,
});

export const searchData = atom({
  key: "searchData",
  default: {
    Account: "",
    CaseNumber: "",
    Contact: "",
    CreatedBy: "",
    CreatedDate: "",
    Status: "",
    ActionRequiredOrNotificationC: "",
    ContactId: null,
    ActionReqOrNotifId: null,
    StatusId: null,
    Sort: "",
  },
});

export const scorecardSaving = atom({
  key: "scorecardSaving",
  default: false,
});

export const selectedRowsStateToDelete = atom<SelectedRowsToDelete | undefined>(
  {
    key: "selectedRowsStateToDelete",
    default: undefined,
  }
);

export const scorecardFromReports = atom({
  key: "scorecardFromReports",
  default: false,
});

export const scorecardLoading = atom({
  key: "scorecardLoading",
  default: true,
});
